import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const directRemoveUserFromProject = api(({ projectUserId } = {}) =>
    mutate(
        gql`
            mutation DirectRemoveUserFromProject($projectUserId: String!) {
                directRemoveUserFromProject(projectUserId: $projectUserId)
            }
        `,
        { projectUserId },
        { returns: "directRemoveUserFromProject" }
    )
)
